export const lambdaUrl = "https://hhoyxkebj4.execute-api.us-east-2.amazonaws.com/prod";



// WEBPACK FOOTER //
// ./src/config.js